export const DEFAULT_REPORT_ORDER: string[] = [
    'balance',
    'APBS',
    'income',
    'APIS',
    'cashflow',
    'notes',
    'AOP',
    'Ems',
    'Fas',
    'FCP',
];
